<div *ngIf="data">
  <div
    class="d-flex flex-column"
    *ngIf="
      data?.exportFormatId != 4 &&
      data?.exportFormatId != 5 &&
      data?.exportFormatId != 2933 &&
      data?.exportFormatId != 2942
    "
  >
    <p class="text-left" *ngIf="data?.status == 1">
      {{ "success" | translate : param }}
    </p>
    <p class="text-left" *ngIf="data?.status != 1">
      {{ "fail" | translate : param }}
    </p>
  </div>
  <div
    class="d-flex flex-column"
    *ngIf="
      data?.exportFormatId == 4 ||
      data?.exportFormatId == 5 ||
      data?.exportFormatId == 2933 ||
      data?.exportFormatId == 2942
    "
  >
    <div
      class="lH-sm"
      *ngIf="
        data?.inQueueCount == 0 && data?.successCount > 0 && data?.failCount > 0
      "
    >
      <p class="eod-text-success text-left">
        {{ "success" | translate : param }} ({{ data?.successCount }}),
      </p>
      <p class="eod-text-danger text-left">
        {{ "fail" | translate : param }} ({{ data?.failCount }})
      </p>
    </div>

    <p
      *ngIf="
        data?.inQueueCount == 0 &&
        data?.successCount == 0 &&
        data?.failCount == 0
      "
    >
      {{ "success" | translate : param }}
    </p>
    <p
      class="eod-text-danger text-left"
      *ngIf="
        data?.inQueueCount == 0 &&
        data?.successCount == 0 &&
        data?.failCount > 0
      "
    >
      {{ "fail" | translate : param }} ({{ data?.failCount }})
    </p>
    <p
      class="eod-text-success text-left"
      *ngIf="
        data?.inQueueCount == 0 &&
        data?.successCount > 0 &&
        data?.failCount == 0
      "
    >
      {{ "success" | translate : param }} ({{ data?.successCount }})
    </p>
    <p
      class="eod-text-danger text-left"
      *ngIf="
        data?.inQueueCount == 0 &&
        data?.successCount > 0 &&
        data?.recalledExpenseCount > 0
      "
    >
      <a
        href="javascript:void(0)"
        class="eod-hyperlink"
        style="pointer-events: none; text-decoration: underline"
      >
        <!-- <i class="fas fa-reply-all"></i> -->
        {{ "Rolled Back Expense" | translate }}  ({{ data?.recalledExpenseCount }})
      </a>

     
    </p>

    <!-- <span *ngIf="
    data?.inQueueCount > 0"
      class="progressBar progressBarSlider height-20px no-padding-right-left margin-top-17"
      style="top:12px;width:100% ;">
      <p>
        <ngb-progressbar type="warning" height="20px" [value]="data?.successCount"
          [max]="data?.inQueueCount + data?.successCount + data?.failCount" striped="true" animated="true">
          <b class="color-black f-9"> Exporting {{data?.successCount}} of {{data?.inQueueCount +
            data?.successCount +
            data?.failCount }}</b>
        </ngb-progressbar>
      </p>
    </span> -->
    <div
      class="position-relative min-w-8em w-100pc mt-1"
      *ngIf="data?.inQueueCount > 0"
    >
      <ngb-progressbar
        type="warning"
        [animated]="true"
        [striped]="true"
        height="1.2rem"
        [value]="data?.successCount"
        [max]="data?.inQueueCount + data?.successCount + data?.failCount"
      ></ngb-progressbar>
      <b
        class="position-absolute top-50 start-50 translate-middle f-10 px-1 w-100pc text-left"
        >Exporting {{ data?.successCount }} of
        {{ data?.inQueueCount + data?.successCount + data?.failCount }}</b
      >
    </div>
    <!-- 
    <span *ngIf="
    data?.inQueueCount == 0 && (data?.status != 1 || data?.status != 0)"
      class="progressBar progressBarSlider height-20px no-padding-right-left margin-top-17"
      style="top:12px;width:100% ;">
      <p>
        <ngb-progressbar type="warning" height="20px" [value]="0"
          [max]="100" striped="true" animated="true">
          <b class="color-black f-9"> Exporting...</b>
        </ngb-progressbar>
      </p>
    </span> -->
  </div>
</div>
